import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';

export default {
    id: {
        type: FILTER_TYPES.text,
    },
    status: {
        type: FILTER_TYPES.text,
    },
    customerId: {
        type: FILTER_TYPES.text,
    },
    websiteId: {
        type: FILTER_TYPES.text,
    },
    planId: {
        type: FILTER_TYPES.text,
    },
    initialInvoiceId: {
        type: FILTER_TYPES.text,
    },
    billingContactId: {
        type: FILTER_TYPES.text,
    },
    deliveryContactId: {
        type: FILTER_TYPES.text,
    },
    quantity: {
        type: FILTER_TYPES.numeric,
    },
    createdTime: {
        type: FILTER_TYPES.datetime,
    },
    updatedTime: {
        type: FILTER_TYPES.datetime,
    },
    startTime: {
        type: FILTER_TYPES.datetime,
    },
    endTime: {
        type: FILTER_TYPES.datetime,
    },
    renewalTime: {
        type: FILTER_TYPES.datetime,
    },
    canceledTime: {
        type: FILTER_TYPES.datetime,
    },
    canceledBy: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            path: 'Subscription/canceledBy/enum',
        },
    },
    cancelCategory: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            path: 'Subscription/cancelCategory/enum',
        },
    },
    cancelDescription: {
        type: FILTER_TYPES.text,
    },
    activationTime: {
        type: FILTER_TYPES.datetime,
    },
    'leadSource/source': {
        type: FILTER_TYPES.text,
    },
    'leadSource/medium': {
        type: FILTER_TYPES.text,
    },
    'leadSource/campaign': {
        type: FILTER_TYPES.text,
    },
    'leadSource/content': {
        type: FILTER_TYPES.text,
    },
    'leadSource/term': {
        type: FILTER_TYPES.text,
    },
    'leadSource/affiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/subAffiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/salesAgent': {
        type: FILTER_TYPES.text,
    },
    'leadSource/amount': {
        type: FILTER_TYPES.numeric,
    },
    'leadSource/path': {
        type: FILTER_TYPES.text,
    },
    'leadSource/ipAddress': {
        type: FILTER_TYPES.text,
    },
    'leadSource/clickId': {
        type: FILTER_TYPES.text,
    },
    'leadSource/createdTime': {
        type: FILTER_TYPES.datetime,
    },
    'leadSource/updatedTime': {
        type: FILTER_TYPES.datetime,
    },

    'billingAddress/firstName': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/lastName': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/address': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/address2': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/organization': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/city': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/region': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/country': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/postalCode': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/email': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/phoneNumber': {
        type: FILTER_TYPES.text,
    },

    'deliveryAddress/firstName': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/lastName': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/address': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/address2': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/organization': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/city': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/region': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/country': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/postalCode': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/email': {
        type: FILTER_TYPES.text,
    },
    'deliveryAddress/phoneNumber': {
        type: FILTER_TYPES.text,
    },

    cancelSource: {
        type: FILTER_TYPES.text,
    },
    rebillNumber: {
        type: FILTER_TYPES.num,
    },
    inTrial: {
        type: FILTER_TYPES.boolean,
    },
};
